module.exports = __webpack_public_path__ + "static/media/filename (14).cbb021cc.png";